<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">黑名单词库</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>拦截方式：</label>
          <el-select v-model="type" placeholder="Select" style="width: 10em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="isSpecial" placeholder="Select" style="width: 10em">
            <el-option v-for="item in isSpecialArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" :searchTypeList="searchTypeList" :searchType="searchType" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
<!--          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editBlackRuleDialog(-1)">添加关键词</el-button>
        </div>
        <div style="display: flex; align-items: center;">
          <p style="color: red; font-size: 12px;">* 关键词操作完成后，系统将在​​10分钟后​​正式生效</p>
          <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>

      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="content" label="关键词" v-if="checkColList.indexOf('关键词') > -1" ></el-table-column>
          <el-table-column property="" label="拦截方式" v-if="checkColList.indexOf('拦截方式') > -1">
            <template #default="scope">
              {{scope.row.type == 1?'星号代替后发送':scope.row.type == 2?'发送默认文案':scope.row.type == 3?'含有即不发送':scope.row.type == 4?'标记发送':scope.row.type == 5?'含有即不发送（感叹号）':scope.row.type == 6?'标记联系方式':''}}
            </template>
          </el-table-column>
          <el-table-column property="createTime" label="添加时间" v-if="checkColList.indexOf('添加时间') > -1"></el-table-column>
          <el-table-column property="" label="重点关键词" v-if="checkColList.indexOf('重点关键词') > -1">
            <template #default="scope">
              {{scope.row.isSpecial == 1?'是':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editBlackRuleDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['delLoading']" type="warning" @click="delBlockRule(scope.$index, scope.row)">删除</el-button>
                <el-button v-if="scope.row.isSpecial == 0" size="small" v-loading="scope.row['updateLoading']" type="success" @click="updateSpecial(scope.$index, scope.row, 1)">设为重点关键词</el-button>
                <el-button v-if="scope.row.isSpecial == 1" size="small" v-loading="scope.row['updateLoading']" type="danger" @click="updateSpecial(scope.$index, scope.row, 0)">取消重点关键词</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getBlockRulePageList, delBlockRule, updateBlockRuleSpecial } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import BlackRuleDialog from "./components/BlackRuleDialog";
import SearchComponents from "@/components/SearchComponents";

export default {
  name: "BlackRule",
  components: { SearchComponents },
  data() {
    return {

      typeArray: [
        {label: '不限', value: -1},
        {label: '星号代替后发送', value: 1},
        {label: '发送默认文案', value: 2},
        {label: '含有即不发送', value: 3},
        {label: '含有即不发送（感叹号）', value: 5},
        {label: '标记发送', value: 4},
        {label: '标记联系方式', value: 6},
      ],
      type: -1,

      isSpecialArray: [
        {label: '不限', value: -1},
        {label: '非重点关键词', value: 0},
        {label: '重点关键词', value: 1},
      ],
      isSpecial: -1,

      //刷新组
      colList: ['关键词', '拦截方式', '添加时间', '重点关键词', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      //搜索
      searchType: 1,
      searchValue: '',
      searchTypeList: [
        {label: '关键词', value: 1},
      ],

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.type = -1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['type'] = this.type;
      param['isSpecial'] = this.isSpecial;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getBlockRulePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editBlackRuleDialog(idx, row) {
      let _title = '';
      let blackForm = {}
      if (idx > -1) {
        _title = '编辑关键词'
        blackForm = Object.assign({}, row);
      }else {
        _title = '添加关键词'
      }
      Dialog.open({
        title: _title,
        component: BlackRuleDialog,
        data: {
          blackForm: blackForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    delBlockRule(idx, row) {
      this.$confirm('确定删除关键词【'+ row.content + '】？')
          .then(() => {
            this.pageDataList[idx]['delLoading'] = true;
            let param = {};
            param['id'] = row.id;
            postFormData(delBlockRule, param).then((data)=>{
              let {code, msg} = data;
              if (code == 200) {
                this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'success'
                })
                this.pageDataList.splice(idx, 1)
              }else {
                this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'warning'
                })
              }
              this.pageDataList[idx]['delLoading'] = false;
            }).catch(()=> {
              this.pageDataList[idx]['delLoading'] = false;
            })
          })
    },


    //重点关键词
    updateSpecial(idx, row, state) {
      this.$confirm('确定'+ (state == 1?'设置':'取消') +'重点关键词【'+ row.content + '】？')
          .then(() => {
            this.pageDataList[idx]['updateLoading'] = true;
            let param = {};
            param['id'] = row.id;
            param['isSpecial'] = state;
            postFormData(updateBlockRuleSpecial, param).then((data)=>{
              let {code, msg} = data;
              if (code == 200) {
                this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'success'
                })
                this.pageDataList[idx]['isSpecial'] = state
              }else {
                this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'warning'
                })
              }
              this.pageDataList[idx]['updateLoading'] = false;
            }).catch(()=> {
              this.pageDataList[idx]['updateLoading'] = false;
            })
          })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
